import type { ButtonHTMLAttributes } from "react";

import SendCircleIcon from "@expert/common-ui/assets/SendCircleIcon";
import { ActionIcon } from "@mantine/core";

import classes from "./MessageInput.module.css";

type SendButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    isDisabled: boolean;
};

export function SendButton(props: SendButtonProps) {
    return (
        <ActionIcon
            className={props.isDisabled ? classes.sendButtonDisabled : classes.sendButtonEnabled}
            data-testid="send-button"
            disabled={props.isDisabled}
            id="SendButton"
            onClick={props.onClick}
            type="submit"
            variant="flat"
            radius={38}
            size={38}
        >
            <SendCircleIcon disabled={props.isDisabled} />
        </ActionIcon>
    );
}
